import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './freightTime.routes';

export class FreightTimeController {

  awesomeThings = [];
  newThing = '';
  stops = ['Kismet', 'Saltaire', 'Fair Harbor', 'Dunewood', 'Atlantique', 'Ocean Beach', 'Seaview', 'Ocean Bay Park'];

  /*@ngInject*/
  constructor($http, FreightTime) {
    this.$http = $http;
    this.$FreightTime = FreightTime;
  }

  $onInit() {
    this.$FreightTime.query()
      .then(response => {
        if(response && response.length > 0) {
          this.times = response[0];
        } else {
          this.times = {
            createdAt: null,
            updatedAt: null,
            oceanBeach: null,
            fairHarbor: null,
            kismet: null,
            seaview: null,
            saltaire: null,
            dunewood: null,
            atlantique: null,
            oceanBayPark: null,
          };
        }
      });
  }

  save(times) {
    if(times) {
      if(times._id) {
        Reflect.deleteProperty(times, '_id');
        Reflect.deleteProperty(times, 'createdAt');
        Reflect.deleteProperty(times, 'updatedAt');
      }
      this.$FreightTime.save(times)
        .then(response => {
          console.log(response);
          this.times = response;
        });
    }
  }
}

export default angular.module('fiapiApp.freightTime', [uiRouter])
  .config(routing)
  .component('freightTime', {
    template: require('./freightTime.pug'),
    controller: FreightTimeController,
    controllerAs: '$freightTime',
    authenticate: true
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/freightTime/freightTime.component.js